module.exports = __webpack_public_path__ + "img/banner-首页.ec26c0be.png";